import axios from 'axios';

export type ReportIncidentRequest = {
  file: File;
  phoneNumber: string;
  latitude: string;
  longitude: string;
};

export type ReportIncidentResponse = {
  success: boolean;
  referenceNumber: string;
};

const basePath = process.env.REACT_APP_API_URL;

export const reportIncident = async (data: FormData): Promise<ReportIncidentResponse> => {
  return axios.post<ReportIncidentResponse>(`${basePath}/reportIncident`, data).then((response) => response.data);
};
